module.exports = __webpack_public_path__ + "img/ls.b5cc6d5b.svg";